const GlobalReducers = (state, action) => {
    switch (action.type) {
        case "increment":
            return { count: state.count + 1 };
        case "decrement":
            return { count: state.count - 1 };
        case "UPDATE_STRUCTURE":
            return { ...state, structures: { ...state.structures, ...action.payload } }
        case "REMOVE_STRUCTURE":
            return { ...state, structures: {} }
        case "UPDATE_COLLECTION":
            return { ...state, collection: { ...state.collection, ...action.payload } }
        case "UPDATE_USERDATA":
            return { ...state, userData: { ...state.userData, ...action.payload } }
        case "UPDATE_SINGLE_COLLECTION":
            return { ...state, single_collection: { ...state.single_collection, ...action.payload } }
        case "UPDATE_SINGLE_TEMPLATE":
            return { ...state, single_template: { ...state.single_template, ...action.payload } }
        case "UPDATE_ALL_COLLECTIONS":
            return { ...state, all_collections: action.payload }
        case "CLEAR_SINGLE_COLLECTION":
            return { ...state, single_collection: {} }
        case "REQ_DETAIL_INDEX":
            return { ...state, req_detail_index: { ...state.req_detail_index, ...action.payload } }
        case "SHOW_REQ_DETAIL":
            return { ...state, show_req_detail: action.payload }
        case "REQ_ID":
            return { ...state, req_id: action.payload }
        case "REQ_DETAIL_TAB":
            return { ...state, req_detail_tab: action.payload }
        case "EXPAND_ALL":
            return { ...state, expand_all: action.payload }
        case "UPDATE_LOADER":
            return { ...state, loader: action.payload }
        case "UPDATE_COLLECTION_SORT":
            return { ...state, collection_sort: action.payload }
        case "MARK_AS_READY":
            return { ...state, mark_as_ready: action.payload }
        case "UPDATE_TABVALUE":
            return { ...state, tab_value: action.payload }
        case "ALERT":
            return { ...state, alert: action.payload }
        case "SIDEBAR_TOGGLE":
            return { ...state, sidebar_toggle: action.payload }
        case "UPDATE_THEME":
            return { ...state, primary_main: action.payload }
        default:
            return state
    }
}

export default GlobalReducers